"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TitledContainer = _interopRequireDefault(require("../../01_atoms/TitledContainer"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _DualPanePageWithSelector = _interopRequireDefault(require("../../02_molecules/DualPanePageWithSelector"));

var _BillingDetailsRightPane = _interopRequireDefault(require("../../02_molecules/BillingDetailsRightPane"));

var _CovidFormRightPane = _interopRequireDefault(require("../../02_molecules/CovidFormRightPane"));

var _PassengersSelectionRightPane = _interopRequireDefault(require("../../02_molecules/PassengersSelectionRightPane"));

var _AddPassengerRightPane = _interopRequireDefault(require("../../02_molecules/AddPassengerRightPane"));

var _OrderDetailsWidget = _interopRequireDefault(require("../../03_organisms/OrderDetailsWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var PassengersDetailsPanel = function PassengersDetailsPanel(_ref) {
  var goToFunc = _ref.goToFunc,
      showOnRight = _ref.showOnRight,
      focusedLeftItemId = _ref.focusedLeftItemId,
      sdk = _ref.sdk;
  var goTo = goToFunc(showOnRight);
  return /*#__PURE__*/_react["default"].createElement(_PassengersSelectionRightPane["default"], {
    sdk: sdk,
    savedPassengers: sdk.passengers.getAllSavedPassengers(),
    selectedPassengers: sdk.passengers.getPassengersSelectedForNextTrip(),
    numberOfPassengers: sdk.bookingProcess.getNumberOfPassengersForCurrentOrder(),
    onPassengerToggle: function onPassengerToggle(d) {
      return sdk.passengers.togglePassengerForNextTrip(d);
    },
    onAddPassenger: function onAddPassenger() {
      goTo('passenger-details/add', 'edit-passengers-button');
    },
    onConfirmPassengers: function onConfirmPassengers() {
      showOnRight(null);
    },
    showOnRight: showOnRight,
    focusedLeftItemId: focusedLeftItemId
  });
};

var AddPassengerPanel = function AddPassengerPanel(_ref2) {
  var goToFunc = _ref2.goToFunc,
      showOnRight = _ref2.showOnRight,
      _ref2$scrollTop = _ref2.scrollTop,
      scrollTop = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop,
      focusedLeftItemId = _ref2.focusedLeftItemId,
      sdk = _ref2.sdk,
      translatorForNamespace = _ref2.translatorForNamespace;
  var goTo = goToFunc(showOnRight);
  return /*#__PURE__*/_react["default"].createElement(_AddPassengerRightPane["default"], {
    showOnRight: showOnRight,
    translatorForNamespace: translatorForNamespace,
    scrollTop: scrollTop,
    focusedLeftItemId: focusedLeftItemId,
    sdk: sdk,
    onAdd: function () {
      var _onAdd = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(p) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return sdk.passengers.createPassengerSelectIt(p);

              case 2:
                // Go back
                goTo('passenger-details', 'edit-passengers-button');

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onAdd(_x) {
        return _onAdd.apply(this, arguments);
      }

      return onAdd;
    }(),
    onBack: function onBack() {
      return goTo('passenger-details', 'edit-passengers-button');
    }
  });
};

var BillingDetailsPanel = function BillingDetailsPanel(_ref3) {
  var sdk = _ref3.sdk,
      showOnRight = _ref3.showOnRight,
      focusedLeftItemId = _ref3.focusedLeftItemId;
  return /*#__PURE__*/_react["default"].createElement(_BillingDetailsRightPane["default"], {
    sdk: sdk,
    onBillingDetailsValidated: showOnRight,
    focusedLeftItemId: focusedLeftItemId
  });
};

var CovidInfoPanel = function CovidInfoPanel(_ref4) {
  var showOnRight = _ref4.showOnRight,
      focusedLeftItemId = _ref4.focusedLeftItemId,
      sdk = _ref4.sdk,
      translatorForNamespace = _ref4.translatorForNamespace,
      history = _ref4.history;
  return /*#__PURE__*/_react["default"].createElement(_CovidFormRightPane["default"], {
    defaultValue: sdk.covid19.getCovidInfo(),
    validateData: function validateData(data) {
      return sdk.covid19.isCovid19InfoValid(data);
    },
    onSubmit: /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(covidInfo) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return sdk.covid19.setCovidInfo(covidInfo);

              case 2:
                // showOnRight(null);
                sdk.bookingProcess.goForward(history);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }(),
    translatorForNamespace: translatorForNamespace,
    showOnRight: showOnRight,
    focusedLeftItemId: focusedLeftItemId
  });
};

var LeftComponent = function LeftComponent(_ref6) {
  var goToFunc = _ref6.goToFunc,
      showOnRight = _ref6.showOnRight,
      currentRightPaneComponentName = _ref6.currentRightPaneComponentName,
      sdk = _ref6.sdk,
      onBack = _ref6.onBack,
      t = _ref6.t,
      history = _ref6.history;
  var goTo = goToFunc(showOnRight);
  return /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: t('Trip details'),
    rightButtonText: t('Back'),
    onRightButtonClick: onBack
  }, /*#__PURE__*/_react["default"].createElement(_OrderDetailsWidget["default"], {
    sdk: sdk,
    numberOfPassengers: sdk.bookingProcess.getNumberOfPassengersForCurrentOrder(),
    selectedPassengers: sdk.passengers.getPassengersSelectedForNextTrip(),
    userSavedCard: sdk.userSettings.getUserSavedCard(),
    payLink: "/book/checkout/pay/",
    passengerId: sdk.billingDetails.getBillingPassengerId(),
    payAmount: sdk.bookingProcess.getCurrentOrderAmount(),
    outboundTrip: sdk.bookingProcess.getSelectedOutboundTrip(),
    returnTrip: sdk.bookingProcess.getSelectedReturnTrip(),
    onEditPassengers: function onEditPassengers() {
      return goTo('passenger-details', 'edit-passengers-button');
    },
    onEditBillingDetails: function onEditBillingDetails() {
      return goTo('billing-details', 'edit-billing-details-button');
    },
    onEditCovidDetails: function onEditCovidDetails() {
      return goTo('covid-info', 'edit-covid-details-button');
    },
    dontHighlight: !!currentRightPaneComponentName,
    history: history
  }));
}; // Define here to keep same Object between renders
// and avoid harmful component remounting


var rightComponentByName = {
  'passenger-details': PassengersDetailsPanel,
  'passenger-details/add': AddPassengerPanel,
  'billing-details': BillingDetailsPanel,
  'covid-info': CovidInfoPanel
};

var GenericTripDetailsPageUI = function GenericTripDetailsPageUI(props) {
  var _props$onBack = props.onBack,
      onBack = _props$onBack === void 0 ? function () {} : _props$onBack,
      sdk = props.sdk,
      history = props.history,
      defaultRightComponent = props.defaultRightComponent,
      defaultFocusedLeftItemId = props.defaultFocusedLeftItemId;
  var translatorForNamespace = sdk.i18n.translatorForNamespace;
  var t = translatorForNamespace('CheckoutPageUI');

  var goToFunc = function goToFunc(showOnRight) {
    return function (elem, leftElem) {
      var url = "/book/".concat(elem);

      if (window.location.pathname.includes(url)) {
        showOnRight(elem, leftElem);
      } else {
        history.push(url);
      }
    };
  };

  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: t('Ready?'),
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_DualPanePageWithSelector["default"], {
    goToFunc: goToFunc,
    onBack: onBack,
    sdk: sdk,
    t: t,
    history: history,
    translatorForNamespace: translatorForNamespace,
    defaultRightComponent: defaultRightComponent,
    defaultFocusedLeftItemId: defaultFocusedLeftItemId,
    leftComponent: LeftComponent,
    rightComponentByName: rightComponentByName
  }));
};

var _default = GenericTripDetailsPageUI;
exports["default"] = _default;